import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import Icon from "../../common/icon/icon.component"
import ProjectCustomerEditForm from "../../quote/project/customerselectform.component"
import IntlProps from "../../state/helpers/IntlProps"
import Payment from "../../state/payment/Payment"

const messages = defineMessages({
    title: {
        id: "edit-payment-contact-modal.title",
        defaultMessage: "Payment Contact Details",
    },
    close_btn: {
        id: "edit-payment-contact-modal.close-btn",
        defaultMessage: "Close",
    },
    save_btn: {
        id: "edit-payment-contact-modal.save-btn",
        defaultMessage: "Save",
    },
})

type OwnProps = {
    payment: Payment
    onChange: (contactId: string) => void
}

const EditPaymentContactModal = (props: OwnProps & IntlProps) => {
    const [show, setShow] = useState<boolean>(false)

    const handleChange = (contactId: string) => {
        props.onChange(contactId)
        setShow(false)
    }

    return (
        <>
            <a href="javascript:void(0);" onClick={() => setShow(true)}>
                {props.payment.getContactName()}
                <Icon className="ml-1" value="pencil-alt" />
            </a>
            <Modal
                show={show}
                size="lg"
                backdrop="static"
                onHide={() => setShow(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FormattedMessage { ...messages.title } />
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ProjectCustomerEditForm
                        className="px-3"
                        value={props.payment.getContactId()}
                        onChange={handleChange}
                        renderContactEnabled
                        isCustomerEditable
                        skipContactCreation
                    />
                </Modal.Body>
            </Modal>
        </>

    )
}

export default injectIntl(EditPaymentContactModal)


// WEBPACK FOOTER //
// ./src/payment/modal/EditPaymentContactModal.tsx